import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { DepthService } from '../http/depths-service';

export default class KosaDepthsStore {
    private _kosaId: number;
    private _loading = false;
    private _depths: number[] = [];

    constructor(kosaId: number) {
        this._kosaId = kosaId;
        makeObservable<KosaDepthsStore, '_loading' | '_depths'>(this, {
            _loading: observable,
            _depths: observable,
            loading: computed,
            depths: computed,
            load: action,
            fromFactory: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }

    get depths(): number[] {
        return this._depths;
    }

    async load() {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await DepthService.byKosa(this._kosaId);
            const raw: number[] = answer.data;
            const cumulative = raw.reduce<number[]>((acc, val) => {
                acc.push((acc[acc.length - 1] ?? 0) + val);
                return acc;
            }, []);
            runInAction(() => {
                this._depths = cumulative;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }

    //!!! Внимание, массив глубин должен быть уже в формате разметки.
    async save(depths: number[]) {
        try {
            await DepthService.updateToKosa(this._kosaId, depths);
            await this.load();
        } catch (e) {
            throw e;
        }
    }

    //!!! Возвращает накопленные глубины от производителя. Если массив пуст, _depths не трогаем,
    //!!! чтобы не затирать уже загруженную разметку отсутствием данных у производителя.
    async fromFactory(): Promise<number[]> {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await DepthService.loadFromFactory(this._kosaId);
            const raw: number[] = answer.data;
            const cumulative = raw.reduce<number[]>((acc, val) => {
                acc.push((acc[acc.length - 1] ?? 0) + val);
                return acc;
            }, []);
            if (cumulative.length > 0) {
                runInAction(() => {
                    this._depths = cumulative;
                });
            }
            return cumulative;
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }
}
